var Broadcaster = require('./broadcaster.js');

var ParallaxHero = {

    init: function() {
        var event = new Event('scroll');
        document.addEventListener('scroll', function () {
        // We're not using scroller as we don't want to debounce the parallax, 
        // not the best for performance however this will only be fired
        // on the homepage. See =>  /scripts.js 
        var step = 1;
        var top = window.pageYOffset;
        var backgrounds = document.querySelectorAll('.parallax-layer');
        var foreground = document.querySelector('.masthead__body-logo');
        var el = document.querySelector('.masthead');
        var elHeight = el.offsetHeight;

        if (top <= elHeight) {
            foreground.style.opacity = "1" - top * .005;
            foreground.style.transform = "translateY(" + top * .5 + 'px' + ")";
        }

        backgrounds.forEach(function (background) {
            var dataSpeed = background.dataset.speed;
            var parallaxSpeed = dataSpeed * .005;

            if (top <= elHeight) {
            step++;
            var bounce = step * parallaxSpeed;
            background.style.transform = "translateY(" + -(top * bounce) + 'px' + ")";
            }
        });
        });
        document.dispatchEvent(event);
    }
    
}

module.exports = ParallaxHero;


// WEBPACK FOOTER //
// ./assets/src/js/modules/parallaxHero.js